<ion-header class="ion-no-border" style="position: relative">
  <ion-toolbar style="padding: 0 calc(0.5 * var(--ion-padding))">
    <ion-searchbar
      mode="ios"
      style="padding: 0"
      clearIcon="close-outline"
      [formControl]="filterCtrl"
      placeholder="Zoeken..."
      #searchBar
      *ngIf="displaySearch"
    ></ion-searchbar>
    <fa-icon
      [icon]="['fal', 'filter']"
      style="cursor: pointer; position: absolute; top: 17px"
      [style.right]="buttonType === 'none' ? '35px' : '85px'"
      *ngIf="displayFilter"
      (click)="filter()"
    ></fa-icon>
    <ion-button
      *ngIf="buttonType !== 'none'"
      slot="end"
      fill="solid"
      color="primary"
      style="margin-left: 12px"
      [id]="buttonType === 'menu' ? 'listSearchMenu' : 'btnSearch'"
      (click)="buttonClick()"
    >
      <fa-icon
        slot="icon-only"
        [icon]="[
          'fal',
          buttonType === 'menu' ? 'ellipsis-vertical' : buttonIcon
        ]"
        size="lg"
      ></fa-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-popover
  *ngIf="buttonType === 'menu'"
  trigger="listSearchMenu"
  triggerAction="click"
  [dismissOnSelect]="true"
>
  <ng-template>
    <ion-content class="ion-background-overlay">
      <ng-content select="[slot=menu]"></ng-content>
    </ion-content>
  </ng-template>
</ion-popover>
